import { render, staticRenderFns } from "./editTheme.vue?vue&type=template&id=2a9e6780&scoped=true&"
import script from "./editTheme.vue?vue&type=script&lang=js&"
export * from "./editTheme.vue?vue&type=script&lang=js&"
import style0 from "./editTheme.vue?vue&type=style&index=0&id=2a9e6780&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9e6780",
  null
  
)

export default component.exports